type LogoBoxProps = {
  children: React.ReactNode;
  sx?: React.CSSProperties;
} & React.HTMLAttributes<HTMLDivElement>;

export const LogoBox = ({ children, sx = {}, ...props }: LogoBoxProps) => {
  return (
    <div
      style={{ height: '20%', position: 'absolute', top: '1rem', left: '1rem', ...sx }}
      {...props}
    >
      {children}
    </div>
  );
};
